<script setup lang="ts">
useHead({
  meta: [
    {
      name: 'description',
      content: 'Miss W - Unparalleled Exposure. Brand Leadership. Networking Advantages',
    },
  ],
})
</script>

<template>
  <div w-full overflow-x-hidden>
    <MissWHeader
      cover="/images/image-167-sponsor.webp"
      title="GET INVOLVED"
      subtitle="UNPARALLELED EXPOSURE. BRAND LEADERSHIP. NETWORKING ADVANTAGES."
      intro="Times are uncertain. Miss W is a certainty.<br>Take the opportunity."
      small-title-size="45px"
      translate-y="-23px"
      mask="transparent"
    />

    <div min-h-1000px w-full lt-lg:mt-80px>
      <SponsorsSection1 />

      <SponsorsSection2 mt-100px />
    </div>

    <IntroductionSponsors pt-200px />
  </div>
</template>

<style scoped>
</style>
